import { gql } from '@apollo/client';

export const DASHBOARD_QUERY_STUDENT_LIST = gql`
  query CMS_Student_List(
    $pageNumber: Int
    $pageSize: Int
    $fullName: String
    $referenceId: String
    $externalId: String
    $registeredPhone: String
    $emailAddress: String
    $partnerCodes: [String]
    $sourceCountryCodes: [String]
  ) {
    listStudents(
      pageNumber: $pageNumber
      pageSize: $pageSize
      fullName: $fullName
      referenceId: $referenceId
      externalId: $externalId
      registeredPhone: $registeredPhone
      emailAddress: $emailAddress
      partnerCodes: $partnerCodes
      sourceCountryCodes: $sourceCountryCodes
    ) {
      totalCount
      pageInfo {
        numPages
        __typename
      }
      edges {
        node {
          id
          fullName
          language
          latestNote
          ongoingOrders {
            id
            referenceId
            stage
            bookingJourney
          }
          referenceId
          systemId
          registeredPhone
          emailAddress
          sourceCountry
          sourceRegion
          partnerCode
          createdAt
          updatedAt
          studentMapping {
            externalId
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const QUERY_COUNTRY = gql`
  query country($pageSize: Int, $pageNumber: Int, $countrySlugs: [String], $name: String) {
    countries(
      pageNumber: $pageNumber
      pageSize: $pageSize
      countrySlugs: $countrySlugs
      name: $name
    ) {
      edges {
        node {
          name
          id
          countryCode
          slug
        }
      }
    }
  }
`;

export const DASHBOARD_STUDENT_ADD_NOTE = gql`
  mutation CreateStudentNote($input: CreateStudentNoteInput!) {
    createStudentNote(input: $input) {
      id
      note
      createdByName
      updatedByName
      createdAt
      updatedAt
    }
  }
`;

export const DASHBOARD_QUERY_STUDENT = gql`
  query CMS_Student($id: ID) {
    listStudents(id: $id) {
      edges {
        node {
          id
          fullName
          emailAddress
          registeredPhone
          sourceCountry
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const DASHBOARD_QUERY_STUDENT_NOTES = gql`
  query CMS_Student_Notes(
    $id: ID
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
    $sortBy: SortBy
  ) {
    listStudents(id: $id) {
      totalCount
      edges {
        node {
          studentNotes(pageNumber: $pageNumber, pageSize: $pageSize, sortBy: $sortBy) {
            totalCount
            edges {
              node {
                id
                studentId
                landlordId
                note
                createdAt
                updatedAt
                createdByName
                updatedByName
              }
            }
          }
        }
      }
    }
  }
`;

export const DASHBOARD_DELETE_STUDENT_NOTE = gql`
  mutation CMS_Delete_Student_Note($input: DeleteStudentNoteInput!) {
    deleteStudentNote(input: $input) {
      id
      note
      createdBy
      updatedBy
      createdByName
      updatedByName
    }
  }
`;

export const DASHBOARD_UPDATE_STUDENT_NOTE = gql`
  mutation CMS_Update_Student_Note($input: UpdateStudentNoteInput!) {
    updateStudentNote(input: $input) {
      id
      landlordId
      studentId
      note
      createdAt
      updatedAt
      createdByName
      updatedByName
    }
  }
`;

export const DASHBOARD_QUERY_STUDENT_LEADS = gql`
  query CMS_Student_Leads(
    $id: ID
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
    $referenceId: String
    $propertyName: ID
    $stages: [OrderStage]
    $bookingJourneys: [BookingJourney]
    $sortBy: OrderSortBy
    $sortDirection: SortDirection
  ) {
    listStudents(id: $id) {
      totalCount
      edges {
        node {
          orders(
            pageNumber: $pageNumber
            pageSize: $pageSize
            referenceId: $referenceId
            propertyName: $propertyName
            stages: $stages
            bookingJourneys: $bookingJourneys
            sortBy: $sortBy
            sortDirection: $sortDirection
          ) {
            totalCount
            pageInfo {
              numPages
            }
            edges {
              node {
                id
                referenceId
                propertyName
                stage
                bookingJourney
                createdAt
                updatedAt
                moveInDate
                moveOutDate
              }
            }
          }
        }
      }
    }
  }
`;
